import { ApiStore } from '@kts-front/call-api';

export const apiStore = new ApiStore({
  baseURL: '/api/',
});
